export default {
  // Main Page
  'pages.open-service.title': 'Open Service',
  'pages.open-service.subTitle':
    'Manage user service activation status, activate or deactivate services for users',
  'pages.open-service.currentSelection': 'Current selection: ',
  'pages.open-service.breadcrumb.serviceManagement': 'Service Management',
  'pages.open-service.breadcrumb.openService': 'Open Service',
  'pages.open-service.batchAdd': 'Batch Add',

  // Left Tree Structure
  'pages.open-service.tree.title': 'Building Floor House Selection',
  'pages.open-service.tree.buildingFloorHouse': 'Building Floor House',

  // Table Related
  'pages.open-service.table.title': 'Open Service List',
  'pages.open-service.table.allData': 'All Data',
  'pages.open-service.table.overdueData': 'Overdue Data',
  'pages.open-service.table.addService': 'Add Service',
  'pages.open-service.table.pagination.total': '{start}-{end} of {total} items',

  // Table Columns
  'pages.open-service.table.columns.index': 'Index',
  'pages.open-service.table.columns.buildingName': 'Building',
  'pages.open-service.table.columns.houseInfo': 'House Info',
  'pages.open-service.table.columns.ownerName': 'Owner Name',
  'pages.open-service.table.columns.serviceName': 'Service Name',
  'pages.open-service.table.columns.serviceName.placeholder':
    'Please select service name',
  'pages.open-service.table.columns.unitPrice': 'Unit Price',
  'pages.open-service.table.columns.serviceStatus': 'Service Status',
  'pages.open-service.table.columns.startDate': 'Start Date',
  'pages.open-service.table.columns.endDate': 'End Date',
  'pages.open-service.table.columns.remarks': 'Remarks',
  'pages.open-service.table.columns.operations': 'Operations',
  'pages.open-service.table.columns.view': 'View',
  'pages.open-service.table.columns.openService': 'Open Service',

  // Status Labels
  'pages.open-service.status.enabled': 'Enabled',
  'pages.open-service.status.disabled': 'Disabled',

  // Operation Messages
  'pages.open-service.message.serviceEnableSuccess':
    'Service enabled successfully',
  'pages.open-service.message.serviceDisableSuccess':
    'Service disabled successfully',
  'pages.open-service.message.operationFailed': 'Operation failed',
  'pages.open-service.message.batchDeleteSuccess': 'Batch delete successful',
  'pages.open-service.message.batchDeleteFailed': 'Batch delete failed',
  'pages.open-service.message.selectRecordsToDelete':
    'Please select records to delete',
  'pages.open-service.message.getDataFailed': 'Failed to get data',
  'pages.open-service.message.batchDeleteConfirm':
    'Are you sure you want to delete the selected {count} records?',
  'pages.open-service.message.batchEnableConfirm.title': 'Batch Open Service',
  'pages.open-service.message.batchEnableConfirm.content':
    'Confirm batch opening of default basic property services for all houses?',
  'pages.open-service.message.batchEnableConfirm.ok': 'Confirm',
  'pages.open-service.message.batchEnableConfirm.cancel': 'Cancel',
  'pages.open-service.message.batchEnableSuccess':
    'Added to task queue, please check the creation results later.',
  'pages.open-service.message.batchEnableFailed':
    'Batch open service failed, please try again later.',

  // Detail Modal
  'pages.open-service.detail.title': 'Open Service Details',
  'pages.open-service.detail.houseInfo': 'House Information',
  'pages.open-service.detail.houseNumber': 'House Info',
  'pages.open-service.detail.ownerName': 'Owner Name',
  'pages.open-service.detail.serviceInfo': 'Service Information',
  'pages.open-service.detail.serviceName': 'Service Name',
  'pages.open-service.detail.unitPrice': 'Unit Price',
  'pages.open-service.detail.serviceStatus': 'Service Status',
  'pages.open-service.detail.servicePeriod': 'Service Period',
  'pages.open-service.detail.startDate': 'Start Date',
  'pages.open-service.detail.endDate': 'End Date',
  'pages.open-service.detail.remarksInfo': 'Remarks Information',
  'pages.open-service.detail.remarks': 'Remarks',
  'pages.open-service.detail.noRemarks': 'No remarks information',

  // Modal Related
  'pages.open-service.modal.editTitle': 'Edit Service',
  'pages.open-service.modal.openTitle': 'Open Service',
  'pages.open-service.modal.batchOpenTitle': 'Batch Open Service',
  'pages.open-service.modal.selectServiceCategory': 'Select Service Category',
  'pages.open-service.modal.editHint':
    'Edit service information (can switch to other service items)',
  'pages.open-service.modal.houseId': 'House ID',
  'pages.open-service.modal.selectHouse': 'Please select house',
  'pages.open-service.modal.selectOwner': 'Select Owner',
  'pages.open-service.modal.selectOwner.placeholder': 'Please select owner',
  'pages.open-service.modal.startDate': 'Start Time',
  'pages.open-service.modal.startDate.placeholder': 'Please select start time',
  'pages.open-service.modal.endDate': 'End Time',
  'pages.open-service.modal.endDate.placeholder':
    'Please select end time (optional)',
  'pages.open-service.modal.serviceStatus': 'Service Status',
  'pages.open-service.modal.serviceStatus.placeholder':
    'Please select service status',
  'pages.open-service.modal.parkingSpace': 'Parking Space',
  'pages.open-service.modal.selectParkingSpace': 'Select Parking Space',
  'pages.open-service.modal.selectParkingSpace.placeholder':
    'Please select parking space',
  'pages.open-service.modal.remarks': 'Remarks',
  'pages.open-service.modal.remarks.placeholder':
    'Please enter remarks information (optional)',
  'pages.open-service.modal.selectServiceItem': 'Select Service Item',
  'pages.open-service.modal.originalService': 'Original Service',
  'pages.open-service.modal.selected': 'Selected',
  'pages.open-service.modal.serviceDetails': 'Service Details',
  'pages.open-service.modal.selectedServiceDetails': 'Selected Service Details',
  'pages.open-service.modal.serviceName': 'Service Name',
  'pages.open-service.modal.unitPrice': 'Unit Price',
  'pages.open-service.modal.billingUnit': 'Billing Unit',
  'pages.open-service.modal.billingCycle': 'Billing Cycle',
  'pages.open-service.modal.serviceDescription': 'Service Description',
  'pages.open-service.modal.confirmBatchOpen': 'Confirm Batch Open',
  'pages.open-service.modal.selectServiceToOpen':
    'Please select service to open',
  'pages.open-service.modal.batchOpenHint.title': 'Batch Open Hint:',
  'pages.open-service.modal.batchOpenHint.content':
    'The system will open this service for all houses. Existing ones will not be reopened, non-existing ones will be opened.',
  'pages.open-service.modal.selectSpecificService':
    'Select specific service item to open',
  'pages.open-service.modal.houseId2': 'House ID',
  'pages.open-service.modal.search': 'Search',
  'pages.open-service.modal.confirmOpen': 'Confirm Open',
  'pages.open-service.modal.backToServiceCategory': 'Back to Service Category',
  'pages.open-service.modal.selectServiceToOpen2':
    'Please select service item to open',
  'pages.open-service.modal.batchOpenService': 'Batch Open',
  'pages.open-service.modal.openService': 'Open Service',

  // Form Validation
  'pages.open-service.form.validation.selectHouse': 'Please select house',
  'pages.open-service.form.validation.selectOwner': 'Please select owner',
  'pages.open-service.form.validation.selectStartDate':
    'Please select start time',
  'pages.open-service.form.validation.selectServiceStatus':
    'Please select service status',
  'pages.open-service.form.validation.selectParkingSpace':
    'Please select parking space',

  // Operation Success Messages
  'pages.open-service.success.serviceEditSuccess':
    'Service edited successfully!',
  'pages.open-service.success.serviceOpenSuccess':
    'Service opened successfully!',
  'pages.open-service.success.batchOpenSuccess':
    'Batch open successful! Opened {count} service records in total',

  // Operation Failed Messages
  'pages.open-service.error.serviceEditFailed': 'Service edit failed',
  'pages.open-service.error.serviceOpenFailed': 'Service open failed',
  'pages.open-service.error.batchOpenFailed': 'Batch open service failed',

  // House Selector
  'pages.open-service.houseSelector.title': 'House Selector',
  'pages.open-service.houseSelector.tree.title':
    'Building Floor House Selection',
  'pages.open-service.houseSelector.table.title': 'House List',
  'pages.open-service.houseSelector.table.title.withSelection':
    'House List - {building} {floor}',
  'pages.open-service.houseSelector.table.empty.forBuilding':
    'Please select building floor to view house information',
  'pages.open-service.houseSelector.table.empty.noSelection':
    'No house data available',
  'pages.open-service.houseSelector.columns.select': 'Select',
  'pages.open-service.houseSelector.columns.floor': 'Floor',
  'pages.open-service.houseSelector.columns.houseNumber': 'House Number',
  'pages.open-service.houseSelector.columns.ownerName': 'Owner Name',
  'pages.open-service.houseSelector.columns.ownerPhone': 'Owner Phone',
  'pages.open-service.houseSelector.columns.area': 'Area',
  'pages.open-service.houseSelector.action.confirm': 'Confirm',
  'pages.open-service.houseSelector.action.cancel': 'Cancel',
  'pages.open-service.houseSelector.message.selectHouse':
    'Please select a house',
  'pages.open-service.houseSelector.error.loadTree':
    'Failed to load building floor house data',
  'pages.open-service.houseSelector.error.loadHouses':
    'Failed to load house list',
  'pages.open-service.houseSelector.pagination.total':
    '{start} to {end} of {total} items',

  // Parking Selector
  'pages.open-service.parkingSelector.title': 'Select Parking Space',
  'pages.open-service.parkingSelector.tree.title': 'Parking Area',
  'pages.open-service.parkingSelector.table.title': 'Parking List',
  'pages.open-service.parkingSelector.selected': 'Selected: {number}',
  'pages.open-service.parkingSelector.columns.parkingNumber': 'Parking Number',
  'pages.open-service.parkingSelector.columns.building': 'Building',
  'pages.open-service.parkingSelector.columns.location': 'Location',
  'pages.open-service.parkingSelector.columns.area': 'Area',
  'pages.open-service.parkingSelector.columns.type': 'Type',
  'pages.open-service.parkingSelector.columns.status': 'Status',
  'pages.open-service.parkingSelector.columns.owner': 'Owner',
  'pages.open-service.parkingSelector.columns.vehicleBinding':
    'Vehicle Binding',
  'pages.open-service.parkingSelector.status.bound': 'Bound',
  'pages.open-service.parkingSelector.status.unbound': 'Unbound',
  'pages.open-service.parkingSelector.status.available': 'Available',
  'pages.open-service.parkingSelector.status.sold': 'Sold',
  'pages.open-service.parkingSelector.status.rented': 'Rented',
  'pages.open-service.parkingSelector.status.reserved': 'Reserved',
  'pages.open-service.parkingSelector.status.disabled': 'Disabled',
  'pages.open-service.parkingSelector.action.select': 'Select',
  'pages.open-service.parkingSelector.action.confirm': 'Confirm Selection',
  'pages.open-service.parkingSelector.action.cancel': 'Cancel',
  'pages.open-service.parkingSelector.message.selectParking':
    'Please select a parking space',
  'pages.open-service.parkingSelector.message.notSoldOrRented':
    'This parking space is not sold or rented',
  'pages.open-service.parkingSelector.message.hasVehicle':
    'This parking space is already bound to a vehicle',
  'pages.open-service.parkingSelector.message.notAvailable':
    'This parking space is not available',
  'pages.open-service.parkingSelector.message.sold':
    'This parking space is sold and cannot be selected',
  'pages.open-service.parkingSelector.error.loadTree':
    'Failed to load parking structure',
  'pages.open-service.parkingSelector.error.loadList':
    'Failed to load parking list',
  'pages.open-service.parkingSelector.error.loadOwnerList':
    'Failed to load owner list',
  'pages.open-service.parkingSelector.error.loadServiceList':
    'Failed to load service list',
  'pages.open-service.parkingSelector.pagination.total': 'Total {total} items',
  'pages.open-service.parkingSelector.table.empty.selectArea':
    'Please select parking area on the left first',
  'pages.open-service.parkingSelector.table.empty.noParking':
    'No parking spaces in this area',
  'pages.open-service.parkingSelector.table.empty.noData': 'No data',

  // Billing Related
  'pages.open-service.billing.cycle.daily': 'Daily',
  'pages.open-service.billing.cycle.monthly': 'Monthly',
  'pages.open-service.billing.cycle.quarterly': 'Quarterly',
  'pages.open-service.billing.cycle.yearly': 'Yearly',
  'pages.open-service.billing.unit.month': 'Month',
  'pages.open-service.billing.unit.day': 'Day',
  'pages.open-service.billing.unit.year': 'Year',
  'pages.open-service.billing.unit.unit': 'Unit',
  'pages.open-service.billing.unit.square_meter': 'Square Meter',

  // Common
  'pages.open-service.common.loading': 'Loading...',
  'pages.open-service.common.selectServiceCategory':
    'Please select service category',
  'pages.open-service.common.selectServiceItem':
    'Please select service item to open',
  'pages.open-service.common.unknown': 'Unknown',
};
